module.exports = __webpack_public_path__ + "static/media/poster4.5080eb56.jpg";